import { render, staticRenderFns } from "./ManageAnnouncementCard.vue?vue&type=template&id=18572ec5&scoped=true&"
import script from "./ManageAnnouncementCard.vue?vue&type=script&lang=js&"
export * from "./ManageAnnouncementCard.vue?vue&type=script&lang=js&"
import style0 from "./ManageAnnouncementCard.vue?vue&type=style&index=0&id=18572ec5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18572ec5",
  null
  
)

export default component.exports